












































































































































import { Component, Vue } from 'vue-property-decorator';
import AddAndEdit from './addAndEdit.vue';
import Arrange from './arrange.vue';
import {
  getTenantData,
  deleteTenant,
} from '@/serve/medicalAppointment/institutionManage';
import areaDetail from '@/utils/areaDetail';
import { natureOptions, gradeOptions } from './options';

@Component({
  name: 'InstitutionManage',
  components: { AddAndEdit, Arrange },
  filters: {
    changeStatus(num: 0 | 9): string {
      return num === 9 ? '冻结' : '正常';
    },
  },
})
export default class InstitutionManage extends Vue {
  public natureOptions = natureOptions;
  public gradeOptions = gradeOptions;
  public tableHeaderStyle = {
    fontSize: '14px',
    background: '#fafafa',
    color: 'black',
  };
  public form = {
    nature: '',
    name: '',
    grade: '',
  };
  public page = {
    current: 1,
    size: 10,
  };
  public tenantData = [];
  public total = 0;
  public IsIndex = true;
  public IsArrange = false;

  public created() {
    this.getTenantData();
  }

  public async getTenantData(): Promise<void> {
    const res = await getTenantData(this.$changNull({ ...this.page, ...this.form }));
    const arr = (res.data && res.data.records) || [];
    arr.forEach(
      (ele: {
        realAddress: string;
        province: string;
        city: string;
        district: string;
      }) => {
        ele.realAddress =
          ((areaDetail as any).provinceList[ele.province] || '') +
          ((areaDetail as any).cityList[ele.city] || '') +
          ((areaDetail as any).countyList[ele.district] || '');
      }
    );
    this.tenantData = arr;
    this.total = (res.data && res.data.total) || 0;
  }

  public handleSizeChange(val: number): void {
    this.page.size = val;
    this.getTenantData();
  }

  public handleCurrentChange(val: number): void {
    this.page.current = val;
    this.getTenantData();
  }

  public search() {
    this.page.current = 1;
    this.getTenantData();
  }

  public back(refresh?: boolean) {
    this.IsIndex = true;
    if (refresh) {
      this.getTenantData();
    }
  }

  public arrangeBack() {
    this.IsIndex = true;
    this.IsArrange = false;
  }

  public editRow(row: { id: string }): void {
    this.IsIndex = false;
    this.$nextTick(() => {
      (this.$refs.AddAndEdit as AddAndEdit).getTenant(row);
    });
  }

  public batchRemove() {
    const list = (this.$refs.table as any).selection || [];
    if (!list.length) {
      this.$message.warning('请选择要删除的机构');
      return;
    }
    this.deleteRow(list);
  }

  public deleteRow(list: { id: number }[]): void {
    (this as any).$messageBox
      .confirm('您确定是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(async () => {
        const ids = list.map((ele) => ele.id);
        const res = await deleteTenant(ids);
        if (res.success) {
          this.$message({
            message: '删除成功',
            type: 'success',
          });
          this.getTenantData();
        }
      });
  }

  public resetForm() {
    this.form = {
      nature: '',
      name: '',
      grade: '',
    };
    this.page = {
      current: 1,
      size: 10,
    };
    this.getTenantData();
  }

  public arrange(row: { id: number }) {
    this.IsIndex = false;
    this.IsArrange = true;
    this.$nextTick(() => {
      (this.$refs.Arrange as Arrange).getArrange(row);
    });
  }
}
